﻿
/// Javascript object that handles all interaction with the LiveWebdialerExample page.
var LiveWebdialerPsynot = function () {

    // internal config object, to storte email, token and urls.
    var config = {};

    var statusDiv;
    var currentCallsDiv;

    // the currently used authenticationurl (since we try a different urls if one fails)
    var currentAuthenticationUrlIndex = -1;

    // the webdialerHub, used for communication after authentication
    var webDialerHub;

    // the retrieved serviceurl after authentication, which is used to connect signalR to.
    var serviceUrl;

    // internal states, used to disable/enable buttons.
    var isAuthenticated;
    var isServiceConnected;
    var isPhoneConnected;
    var areSettingsApplied;

    var pciIntervallId;
    var kpcIntervallId;

    // 260721nrai: r4 merge — SignalR reconnect/backoff
    var reconnectAttempt = 0;
    var reconnectTimerId = null;
    var maxReconnectDelayMs = 60000;
    var lwdReconnectScheduled = false;
    var hubLifecycleHandlersBound = false;


    /////////////////////////////////
    /* Call handling */
    /////////////////////////////////

    var acceptCall = function (callToAccept) {
        webDialerHub.server.acceptCall(callToAccept)
            .done(function () {
                logAndCheckUi('success', 'Angenommen ', (callToAccept));
            }).fail(function () {
                logAndCheckUi('danger', 'Annehmen nicht möglich ', (callToAccept));
            });
    };

    var stopCall = function (callToStop) {
        webDialerHub.server.stopCall(callToStop)
            .done(function () {
                logAndCheckUi('success', 'Beendet ', (callToStop));
            }).fail(function () {
                logAndCheckUi('danger', 'Beenden nicht möglich ', (callToStop));
            });
    };

    var holdCall = function (callToHold) {
        webDialerHub.server.holdCall(callToHold)
            .done(function () {
                logAndCheckUi('success', 'Gehalten ', (callToHold));
            }).fail(function () {
                logAndCheckUi('danger', 'Halten nicht möglich ', (callToHold));
            });
    };

    var unholdCall = function (callToUnHold) {
        webDialerHub.server.unHoldCall(callToUnHold)
            .done(function () {
                logAndCheckUi('success', 'Zurückgeholt ', (callToUnHold));
            }).fail(function () {
                logAndCheckUi('danger', 'Zurückholen nicht möglich ', (callToUnHold));
            });
    };

    var transferCall = function (callToTransfer, numberToTransferTo) {
        webDialerHub.server.transferCall(callToTransfer, numberToTransferTo)
            .done(function () {
                logAndCheckUi('success', 'Verbunden ', (callToTransfer));
            }).fail(function () {
                logAndCheckUi('danger', 'Verbinden nicht möglich ', (callToTransfer));
            });
    };


    /////////////////////////////////
    /* Call handling END */
    /////////////////////////////////

    /////////////////////////////////
    /* UI related methods */
    /////////////////////////////////

    var formatCallObject = function (callObj) {
        if (!callObj) {
            return 'KEINE ANRUFER INFO';
        }
        //return 'From: ' + callObj.CallingFrom + ' To: ' + callObj.CalledTo;
        return 'von ' + callObj.CallingFrom + ' an ' + callObj.CalledTo;
    };

    var updateStatusElement = function (elementId, isOk, okMessage, failMessage) {
        var statusElement = $('#' + elementId);
        statusElement.text(isOk ? okMessage : failMessage);
        if (isOk) {
            statusElement.removeClass('lwdlog-danger');
            statusElement.addClass('lwdlog-success');
        } else {
            statusElement.addClass('lwdlog-danger');
            statusElement.removeClass('lwdlog-success');
        }
    };

    var disableButtonElement = function (button, isDisabled) {
        button.prop('disabled', isDisabled);
        if (isDisabled) {
            button.addClass('disabled');
        } else {
            button.removeClass('disabled');
        }
    };

    var updateStatusUi = function () {
        updateStatusElement('lwd_authenticationStatus',     isAuthenticated,    'Authentifiziert', 'NICHT authentifiziert');
        updateStatusElement('lwd_serviceConnectionStatus',  isServiceConnected, 'Mit Service verbunden', 'NICHT mit Service verbunden');
        updateStatusElement('lwd_phoneConnectionStatus',    isPhoneConnected,   'Mit Telefon '+$('#lwd_phone_ext').val()+' verbunden', 'NICHT mit Telefon '+$('#lwd_phone_ext').val()+' verbunden');
        updateStatusElement('lwd_serviceUrlStatus',         serviceUrl,         'Verwendete Service-URL: ' + serviceUrl, 'Authentifizierung ist erforderlich um Service-URL zu erhalten');

        // Check if necessary for Psynot
        //var isAuthenticationEnabled = areSettingsApplied && !isAuthenticated;
        //disableButtonElement($('#authenticate'), !isAuthenticationEnabled);
    };

    /// log the given text to our log div and update the status ui (else.g. is phone connected,...)
    var logAndCheckUi = function (logLevel, msg, callerObj) {
        var logTime=Date();
        var logEntryDiv = $('<div class="lwdlog lwdlog-' + logLevel + '" style="display: none;"></div>');
        var call_id = null;
        var calling_from = null;
        var called_to = null;
        var logMsg = moment(logTime).format('DD.MM.YYYY HH:mm:ss') + ': ' + msg
        if (callerObj) {
            if (callerObj.CallId) {
                call_id = callerObj.CallId;
            }
            if (callerObj.CallingFrom) {
                calling_from=callerObj.CallingFrom;
                called_to=callerObj.CalledTo;
                logMsg+=formatCallObject(callerObj)
            }
        }
        logEntryDiv.text(logMsg);
        logEntryDiv.prependTo(logDiv).show('fast');

        updateStatusUi();

        // Psynot
        bsLogCall(logLevel, logTime, msg, call_id, calling_from, called_to);
    };

    /// update/create the ui element of a single call
    /// depending on the call's state, buttons of the call div (hang-up,...) are enabled/disabled
    var updateCallStateUi = function (callObj, callState) {
        var callId = callObj.CallId;

        var existingCallDiv = $('#' + callId, currentCallsDiv);
        // create the div for the call if it does not exist yet.
        if (existingCallDiv.length <= 0) {

            //var newCallDiv = $('<div id="' + callId + '" style="display: none;"><ul class="button-group round"><li><a href="#" class="button small call-stop">Beenden</a></li><li><a href="#" class="button small call-accept">Annehmen</a></li><li><a href="#" class="button small call-hold">Halten</a></li><li><a href="#" class="button small call-unhold">Zurückholen</a></li><li><a href="#" class="button small call-transfer">Verbinden</a></li></ul><input type="text" class="call-transfer-number"></input><div class="call-events"></div></div>');
            //<li><a href="#" class="button small call-transfer">Verbinden</a></li>
            // Psynot
            var newCallDivHtml='<div id="' + callId + '" style="display: none;">'
            newCallDivHtml+='<ul class="button-group round"><li><a href="#" class="button small call-stop">Beenden</a></li><li><a href="#" class="button small call-accept">Annehmen</a></li><li><a href="#" class="button small call-hold">Halten</a></li><li><a href="#" class="button small call-unhold">Zurückholen</a></li></ul>'
            newCallDivHtml+='<div class="calling_from_description h3size"></div>'
            newCallDivHtml+='<div class="call-events"></div>'
            newCallDivHtml+='</div>'

            var newCallDiv = $(newCallDivHtml);
            newCallDiv.prependTo(currentCallsDiv).show('fast');
            existingCallDiv = newCallDiv;

            $('.call-stop', newCallDiv).click(function () {
                stopCall(callObj);
            });
            $('.call-accept', newCallDiv).click(function () {
                acceptCall(callObj);
            });

            $('.call-hold', newCallDiv).click(function () {
                holdCall(callObj);
            });

            $('.call-unhold', newCallDiv).click(function () {
                unholdCall(callObj);
            });

            $('.call-transfer', newCallDiv).click(function () {
                var transferToInput = $('.call-transfer-number', existingCallDiv);
                transferCall(callObj, transferToInput.val());
            });
        }

        // 1. update the call info label with the call info
        //var infoMsg = ' &rarr; ' + callState + ' (', (callObj) + ')';
        //var callInfoDiv = $('.call-events', existingCallDiv);

        //var infoEntryElement = $('<span class="small">' + infoMsg + '</span><br/>');
        //callInfoDiv.prepend(infoEntryElement);

        var isAcceptCallEnabled = false;
        var isStopCallEnabled = false;
        var isHoldEnabled = false;
        var isUnHoldEnabled = false;
        var isTransferEnabled = false;

        var canMakeCall = false;

        if (callState === 'remoteinuse') {
            // can't do anything... someone is using our line.
        } else if (callState === 'new-outgoing') {
            canMakeCall = true;
            isStopCallEnabled = true;

        } else if (callState === 'new-incoming') {
            canMakeCall = false;
            isAcceptCallEnabled = true;
            // Psynot
            bsLookupCaller(callObj.CallId, callObj.CallingFrom);

        } else if (callState === 'ringing-incoming') {
            isAcceptCallEnabled = true;

        } else if (callState === 'ringing-outgoing') {
            isStopCallEnabled = true;
            // Psynot
            bsMakeCall(callObj.CallId, callObj.CalledTo);

        } else if (callState === 'connected-incoming')  {
            isStopCallEnabled = true;
            isHoldEnabled = true;
            isTransferEnabled = true;
            // Psynot
            bsAcceptCall(callObj.CallId, callObj.CallingFrom);

        }  else if (callState === 'connected-outgoing') {
            isStopCallEnabled = true;
            isHoldEnabled = true;
            isTransferEnabled = true;

        } else if (callState === 'hangup') {
            canMakeCall = true;
            // Psynot
            bsStopCall(callObj.CallId);

        } else if (callState === 'onhold-incoming') {
            isStopCallEnabled = true;
            isUnHoldEnabled = true;
            canMakeCall = true;

        } else if (callState === 'onhold-outgoing') {
            isStopCallEnabled = true;
            isUnHoldEnabled = true;
            canMakeCall = true;

        } else if (callState === 'failed') {
            isStopCallEnabled = true;
            // Psynot FINISH!!!
            //bsFailedCall(callObj.CallId, callObj.CallingFrom);

        } else {
            console.log('WARNING: unsupported callState in UI: ' + callState);
        }

        var stopCallButton = $('.call-stop', existingCallDiv);
        disableButtonElement(stopCallButton, !isStopCallEnabled);

        var acceptCallButton = $('.call-accept', existingCallDiv);
        disableButtonElement(acceptCallButton, !isAcceptCallEnabled);

        var holdCallButton = $('.call-hold', existingCallDiv);
        disableButtonElement(holdCallButton, !isHoldEnabled);

        var unHoldCallButton = $('.call-unhold', existingCallDiv);
        disableButtonElement(unHoldCallButton, !isUnHoldEnabled);

        var transferCallButton = $('.call-transfer', existingCallDiv);
        disableButtonElement(transferCallButton, !isTransferEnabled);
        var transferCallNumberInput = $('.call-transfer-number', existingCallDiv);
        disableButtonElement(transferCallNumberInput, !isTransferEnabled);

        disableButtonElement($('#lwd_make_call_button'), !canMakeCall);
        disableButtonElement($('#lwd_call_number'), !canMakeCall);

        disableButtonElement($('#lwd_make_partner_call_button'), !canMakeCall);
        disableButtonElement($('#lwd_call_partner'), !canMakeCall);
    };

    /////////////////////////////////
    /* UI related methods END */
    /////////////////////////////////

    // 260721nrai: r4 merge — SignalR reconnect/backoff
    var clearReconnectTimer = function () {
        if (reconnectTimerId) {
            clearTimeout(reconnectTimerId);
            reconnectTimerId = null;
        }
        lwdReconnectScheduled = false;
    };

    var resetWebDialerHubState = function () {
        webDialerHub = null;
        isPhoneConnected = false;
        isServiceConnected = false;
        isAuthenticated = false;
    };

    var stopSignalRHub = function () {
        try {
            if ($.connection && $.connection.hub && $.connection.hub.state &&
                $.connection.hub.state() !== $.signalR.connectionState.disconnected) {
                $.connection.hub.stop();
            }
        } catch (e) {
            console.log('stopSignalRHub: ' + e);
        }
    };

    var scheduleReconnect = function () {
        if (lwdReconnectScheduled) {
            return;
        }
        lwdReconnectScheduled = true;
        var delayMs = Math.min(2000 * Math.pow(2, reconnectAttempt), maxReconnectDelayMs);
        reconnectAttempt += 1;
        logAndCheckUi('info', 'Neuverbindung in ' + Math.round(delayMs / 1000) + ' s (Versuch ' + reconnectAttempt + ')');
        reconnectTimerId = setTimeout(function () {
            reconnectTimerId = null;
            lwdReconnectScheduled = false;
            currentAuthenticationUrlIndex = -1;
            applyLwdSettings();
        }, delayMs);
    };

    var bindHubLifecycleHandlers = function () {
        if (hubLifecycleHandlersBound) {
            return;
        }
        hubLifecycleHandlersBound = true;

        $.connection.hub.connectionSlow(function () {
            logAndCheckUi('warning', 'SignalR-Verbindung langsam');
        });

        $.connection.hub.reconnecting(function () {
            logAndCheckUi('warning', 'SignalR stellt Verbindung wieder her...');
        });

        $.connection.hub.reconnected(function () {
            reconnectAttempt = 0;
            clearReconnectTimer();
            isServiceConnected = true;
            logAndCheckUi('success', 'SignalR-Verbindung wiederhergestellt');
            connectPhone();
        });

        $.connection.hub.disconnected(function () {
            resetWebDialerHubState();
            $('#lwd_apply_settings_button').show('fast');
            logAndCheckUi('danger', 'Verbindung zum Service wurde getrennt, Neuverbindung wird automatisch versucht...');
            scheduleReconnect();
        });
    };

    var startSignalRHub = function () {
        var transports = ['webSockets', 'longPolling'];

        var tryStart = function (transportIndex) {
            if (transportIndex >= transports.length) {
                isServiceConnected = false;
                logAndCheckUi('danger', 'Es konnte keine Verbindung mit dem Service hergestellt werden');
                scheduleReconnect();
                return;
            }

            stopSignalRHub();

            $.connection.hub.start({ transport: transports[transportIndex] }).done(function () {
                reconnectAttempt = 0;
                clearReconnectTimer();
                isServiceConnected = true;
                logAndCheckUi('success', 'Mit dem Service verbunden (' + transports[transportIndex] + ')');
                webDialerHub.server.getLineInformation()
                    .done(function (result) {
                        if (result) {
                            logAndCheckUi('success', 'Informationen über verfügbare Telefone erhalten');
                            connectPhone();
                            createPhoneDropdownEntries(result);
                            disableButtonElement($('#lwd_connect_phone_button'), false);
                        } else {
                            logAndCheckUi('danger', 'Informationen über verfügbare Telefone nicht verfügbar');
                        }
                    })
                    .fail(function () {
                        logAndCheckUi('danger', 'Fehler beim Versuch Telefoninfos abzurufen');
                    });
            }).fail(function () {
                if (transportIndex + 1 < transports.length) {
                    logAndCheckUi('warning', transports[transportIndex] + ' fehlgeschlagen, versuche ' + transports[transportIndex + 1] + ' ...');
                    tryStart(transportIndex + 1);
                } else {
                    isServiceConnected = false;
                    logAndCheckUi('danger', 'Es konnte keine Verbindung mit dem Service hergestellt werden');
                    scheduleReconnect();
                }
            });
        };

        tryStart(0);
    };

    
    /// iniitalize the singalR hub and register for the events we receive.
    var initWebDialerConnectionEvents = function (url) {
        bindHubLifecycleHandlers();

        $.connection.hub.url = url + 'signalr';
        $.connection.hub.qs = { 'email': config.email, 'token': config.token };
        $.connection.hub.logging = true;

        webDialerHub = $.connection.webDialerHub;

        webDialerHub.client.outgoingRinging = function (callerObj) {
            updateCallStateUi(callerObj, 'ringing-outgoing');
            logAndCheckUi('info', 'Ausgehend läuten ', (callerObj));
        };
        webDialerHub.client.outgoingHangup = function (callerObj) {
            updateCallStateUi(callerObj, 'hangup');
            logAndCheckUi('info', 'Ausgehend aufgelegt ', (callerObj));
        };
        webDialerHub.client.outgoingConnected = function (callerObj) {
            updateCallStateUi(callerObj, 'connected-outgoing');
            logAndCheckUi('info', 'Ausgehend verbunden ', (callerObj));
        };
        webDialerHub.client.incomingRinging = function (callerObj) {
            updateCallStateUi(callerObj, 'ringing-incoming');
            logAndCheckUi('info', 'Eingehend läuten ', (callerObj));
        };
        webDialerHub.client.incomingHangup = function (callerObj) {
            updateCallStateUi(callerObj, 'hangup');
            logAndCheckUi('info', 'Eingehend aufgelegt ', (callerObj));
        };
        webDialerHub.client.incomingConnected = function (callerObj) {
            updateCallStateUi(callerObj, 'connected-incoming');
            logAndCheckUi('info', 'Eingehend verbunden ', (callerObj));
        };

        webDialerHub.client.callFailed = function (callerObj) {
            updateCallStateUi(callerObj, 'failed');
            logAndCheckUi('info', 'Anruf fehlgeschlagen ', (callerObj));
        };

        webDialerHub.client.incomingCallOnHold = function (callerObj) {
            updateCallStateUi(callerObj, 'onhold-incoming');
            logAndCheckUi('info', 'Eingehend Gehalten ', (callerObj));
        };

        webDialerHub.client.outgoingCallOnHold = function (callerObj) {
            updateCallStateUi(callerObj, 'onhold-outgoing');
            logAndCheckUi('info', 'Ausgehend Gehalten ', (callerObj));
        };

        webDialerHub.client.incomingNew = function (callerObj) {
            updateCallStateUi(callerObj, 'new-incoming');
            logAndCheckUi('info', 'Eingehend Neu ', (callerObj));
        };

        webDialerHub.client.outgoingNew = function (callerObj) {
            updateCallStateUi(callerObj, 'new-outgoing');
            logAndCheckUi('info', 'Ausgehend Neu ', (callerObj));
        };

        webDialerHub.client.remoteInUse = function (callerObj) {
            updateCallStateUi(callerObj, 'remoteinuse');
            logAndCheckUi('info', 'Besetzt ', (callerObj));
        };

        webDialerHub.client.controlSessionStatusChanged = function (phoneControlSessionStatus) {
            logAndCheckUi('info', 'Session Status geändert: ' + phoneControlSessionStatus);
        };
    };


    var makeAuthenticationRequest = function (authenticationUrl, email, token, onSuccess, onError) {
        $.ajax(authenticationUrl, {
            method: 'POST',
            cache: false,
            data: {
                email: email,
                token: token
            },
            success: onSuccess,
            error: onError
        });
    }

    /// apply the current user input and start authentication/connection process
    var applyLwdSettings = function () {
        // STEP 1: 
        // authenticate, which gives us the url we should use for communication, once we are authenticated.
        // we get a list or urls/authenticationservices we should try - first one working wins...
        // we could add more logic here, e.g. do not try a url that did not work last time for x minutes...

        var email = $('#lwd_email').val();
        var token = $('#lwd_token').val();
        var authenticationUrls = $('#lwd_authurl').val().split(',');
        config.authenticationUrls = authenticationUrls;
        // remember email/token
        config.email = email;
        config.token = token;
        
        currentAuthenticationUrlIndex = currentAuthenticationUrlIndex + 1;
        var authenticationUrl = config.authenticationUrls[currentAuthenticationUrlIndex];

        logAndCheckUi('info', 'Authentifizierung ...');

        //console.log('applyLwdSettings: email:'+email+', token URIencoded: '+encodeURI(token));

        makeAuthenticationRequest(authenticationUrl, email, token,
            function(response) {
                // we successfully authenticated, remember the serviceUrl
                serviceUrl = response.ServiceUrl;
                $('#lwd_serviceUrl').text(serviceUrl);
                
                isAuthenticated = true;
                logAndCheckUi('success', 'Authentifizierung erfolgreich');
                $('#lwd_apply_settings_button').hide('fast');

                // STEP 2
                // now we can go to the servuceUrl and init signalR/Websockets communication.
                //logAndCheckUi('info', 'Connecting to server: ' + serviceUrl + ' ...');
                logAndCheckUi('info', 'Mit LiveWebDialer Service verbinden ...');
                initWebDialerConnectionEvents(serviceUrl);
                startSignalRHub();

            },
            function (xhr) {
                // an error occured during authentication, just try a different authentication url.
                // usually you want to check here what the HTTP resultcode/message was (e.g. if token/user is invalid it will not work, no matter how often you try)
            
                if (currentAuthenticationUrlIndex >= config.authenticationUrls.length - 1) {
                // ok, give up, we tried all urls....
                currentAuthenticationUrlIndex = -1;
                
                isAuthenticated = false;
                logAndCheckUi('danger', 'Authentifizierungsfehler');
                scheduleReconnect();
                return;
            }

            logAndCheckUi('danger', 'Fehler während Authentifizierungsversuch... versuchen Sie eine andere Authentifizierungs-URL');
            applyLwdSettings();
        });
    };



    var createPhoneDropdownEntries = function (result) {
        $('#lwd_connectNumber').empty();

        var controllableDevices = result.ControllablePhones;
        for (let i = 0; i < controllableDevices.length; i++) {
            const device = controllableDevices[i];
            $('<option/>', {
                value: device.PhoneName,
                html: `${device.PhoneNumber} (${device.PhoneName})`
            }).appendTo('#lwd_connectNumber');
        }
    }

    var connectPhone = function () {
        var connectTo = $('#lwd_phone_id').val();
        var connectToExt = $('#lwd_phone_ext').val();
        if(isAuthenticated) {
            logAndCheckUi('info', `Verbindung zu Telefon ${connectTo} (${connectToExt}) ...`);
            //console.log(' webDialerHub.server.connectToPhoneByName: connectTo:'+connectTo+', connectToExt:'+connectToExt);
            webDialerHub.server.connectToPhoneByName(connectTo)
                    .done(function () {
                        isPhoneConnected = true;
                        disableButtonElement($('#lwd_make_call_button'), false);
                        disableButtonElement($('#lwd_make_partner_call_button'), false);
                        logAndCheckUi('success', `Mit Telefon ${connectTo} (${connectToExt}) verbunden. Anrufe können empfangen und getätigt werden`);

                    })
                    .fail(function () {
                        isPhoneConnected = false;
                        logAndCheckUi('danger', `Verbindung mit Telefon ${connectTo} (${connectToExt}) fehlgeschlagen`);
                    });
        } else {
            logAndCheckUi('danger', `Vor Verbindung zu Telefon ${connectTo} (${connectToExt}) mit Service verbinden!`)
        }        
    };


    var connectPhoneFromList = function () {
        if(isAuthenticated) {
            var connectTo = $("#lwd_connectNumber option:selected").val();
            logAndCheckUi('info', `Verbindung zu Telefon ${connectTo}...`);
            webDialerHub.server.connectToPhoneByName(connectTo)
                .done(function () {
                    isPhoneConnected = true;
                    disableButtonElement($('#lwd_make_call_button'), false);
                    disableButtonElement($('#lwd_make_partner_call_button'), false);
                    logAndCheckUi('success', `Mit Telefon verbunden. Anrufe können empfangen und getätigt werden`);

                })
                .fail(function () {
                    isPhoneConnected = false;
                    logAndCheckUi('danger', `Verbindung mit Telefon fehlgeschlagen`);
                });
        } else {
            logAndCheckUi('danger', 'Vor Verbindung zu Telefon mit Service verbinden!')
        }
    };


    // ==================== Workaround functions for breaking Phone connections, before usage of WebSockets ============

    var startKeepPhoneConnection = function () {
            if (!kpcIntervallId) {
                kpcIntervallId = setInterval(keepPhoneConnection, 10000);
            }
    }

    var keepPhoneConnection = function() {
        // deprecated since 230512, due to use of webSockets
        var connectTo = $('#lwd_phone_id').val();
        webDialerHub.server.connectToPhoneByName(connectTo)
            .done(function () {
                //console.log('keepPhoneConnection OK at '+moment(Date()).format('DD.MM.YYYY HH:mm:ss'));
            })
            .fail(function () {
                console.log('keepPhoneConnection FAILED for '+connectTo+' at '+moment(Date()).format('DD.MM.YYYY HH:mm:ss'));
                logAndCheckUi('danger', 'keepPhoneConnection FAILED for ', ({CalledTo: connectTo}));
            });
    }

    var startPollingCallInformation = function () {
        if (!pciIntervallId) {
            pciIntervallId = setInterval(pollCallInformation, 2000);
        }
    }

    var stopPollingCallInformation = function () {
        clearInterval(pciIntervallId);
        // release our intervalID from the variable
        pciIntervallId = null;
    }


    var pollCallInformation = function() {
        //callInfo.keys: state,always,then,promise,pipe,done,fail,progress
        // [Log] callInfo.state():pending
        // [Log] callInfo.always():pending
        // [Log] callInfo.then():pending
        // [Log] callInfo.promise():pending
        // [Log] callInfo.pipe():pending
        // [Log] callInfo.done():pending
        // [Log] callInfo.fail():pending
        // [Log] callInfo.progress():pending
        if(1111111==2222222 && isAuthenticated) {
            callInfo=webDialerHub.server.GetAllCallInformation();
            //console.log('callInfo.keys: '+Object.keys(callInfo));
            //console.log('-----------------------------------------');
            //console.log('callInfo.state():'+callInfo.state());
            //console.log('callInfo.always().state():'+callInfo.always().state());
            //console.log('callInfo.then().state():'+callInfo.then().state());
            //console.log('callInfo.promise().state():'+callInfo.promise().state());
            //console.log('callInfo.pipe().state():'+callInfo.pipe().state());
            //console.log('callInfo.done().state():'+callInfo.done().state());
            //console.log('callInfo.fail().state():'+callInfo.fail().state());
            //console.log('callInfo.progress().state():'+callInfo.progress().state());
        }
    }
    // ================================================================================================================


    var init_ = function () {
        currentAuthenticationUrlIndex = -1;
        logDiv = $('#lwd_log');
        statusDiv = $('#lwd_status');
        currentCallsDiv = $('#lwd_current_calls');

        $('#lwd_clear_log').click(function () {
            logDiv.empty();
        });

        $('#lwd_clear_calls').click(function () {
            currentCallsDiv.empty();
        });

        //$('form').submit(function (event) {
            // prevent form submission, e.g. when user presses enter...
        //    event.preventDefault();
        //});

        $('#lwd_call_number').keypress(function (e) {
            if (e.which === 13) {
                // simulate click on makecall when user presses enter
                $('#lwd_make_call_button').click();
            }
        });
        
        $('#lwd_apply_settings_button').click(function () {
            clearReconnectTimer();
            reconnectAttempt = 0;
            currentAuthenticationUrlIndex = -1;
            applyLwdSettings();
        });
        $('#lwd_connect_phone_button').click(connectPhoneFromList);
        $('#lwd_phoneConnectionStatus').click(connectPhone);

        $('#lwd_make_call_button').click(function () {
            // just pass in the called number to start a call - if it succeeds, fails, we will get the according events
            $('#called_type').val($('#called_number_type  option:selected').val());
            var call = {
                CalledTo: $('#lwd_call_number').val()
            };
            webDialerHub.server.makeCall(call)
            .done(function () {
                logAndCheckUi('success', 'Anruf getätigt ', (call));
            }).fail(function () {
                logAndCheckUi('danger', 'Anruf kann nicht getätigt werden ', (call));
            });
        });

        $('#lwd_make_partner_call_button').click(function () {
            // just pass in the called number to start a call - if it succeeds, fails, we will get the according events
            $('#called_type').val('partner');
            var call = {
                CalledTo: $('#lwd_call_partner  option:selected').val()
            };
            webDialerHub.server.makeCall(call)
                .done(function () {
                    logAndCheckUi('success', 'Anruf getätigt ', (call));
                }).fail(function () {
                logAndCheckUi('danger', 'Anruf kann nicht getätigt werden ', (call));
            });
        });

        $('#lwd_make_client_call_button').click(function () {
            // just pass in the called number to start a call - if it succeeds, fails, we will get the according events
            $('#called_type').val('client');
            var call = {
                CalledTo: $('#lwd_call_client').val()
            };
            webDialerHub.server.makeCall(call)
                .done(function () {
                    logAndCheckUi('success', 'Anruf getätigt ', (call));
                }).fail(function () {
                logAndCheckUi('danger', 'Anruf kann nicht getätigt werden ', (call));
            });
        });

        // disable makecall button on startup
        disableButtonElement($('#lwd_make_call_button'), true);
        disableButtonElement($('#lwd_make_partner_call_button'), true);
        updateStatusUi();

        // for Psynot autoconnect with credentials in form_fields
        applyLwdSettings();

        // DEBUG & TEST regularly get Call Information - to recognize missing onHook events from LWD
        // normally, start polling on accepting a call.
        //startPollingCallInformation();

        // Psynot - Simulate
       // bsAcceptCall('dummy', '+436991234');
    };

    return {
        init: init_
    };
};

// 260507nrai: bundle exposes constructor for inline scripts (calls/_webdialer)
window.LiveWebdialerPsynot = LiveWebdialerPsynot;
